import React, {Component} from "react";
//import  {
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler, ScrollView
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import store from "../../../../redux/store";
import {
    serviceActionListFilter,
    serviceActionError
} from "./action/ActionListMessageOperatorSatiaScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import * as NavigationService from "../../../../redux/NavigationService";
import {Tools} from "../../../../tools/Tools";
import HMListCheckBox from "../../../../customviews/HMListCheckBox";
import FontAwesomeIcon from 'react-native-vector-icons/dist/FontAwesome';
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMIcon from "./../../../../customviews/HMIcon";
import HMButton from "../../../../customviews/HMButton";
import HMTextInput from "../../../../customviews/HMTextInput";
import HMTextInputEfects from "../../../../customviews/HMTextInputEfects";
import HMModal from "../../../../customviews/modal/HMModal";
import HMAlert from "../../../../customviews/HMAlert";

let container = null;
export default class ListMessageOperatorSatiaScreen extends Component {
    constructor(props) {
        super(props);
        let myLocation = store.getState().reducerSplashSatiaScreen.Location;
        let lat = 0
        let long = 0
        if (!myLocation) {
            lat = parseFloat(myLocation ? myLocation.coords.latitude : 0);
            long = parseFloat(myLocation ? myLocation.coords.longitude : 0);
            // long = parseFloat(props.navigation && props.route.params ? props.route.params.position.coords.longitude : props.position ? props.position.coords.longitude : 0);

        }
        this.state = {
            OneDo: true,
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: false,
            indexFilter: 0,

            lat: lat,
            long: long,
            dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                name: 'در دست اقدام',
                id: 2
            }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                name: 'تایید واحد',
                id: 5
            },],
            textCondition: null,
            arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                name: 'تکراری در دست اقدام',
                id: 3
            }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],
            Condition: {id: 0, value: "وضعیت پیام"},

            arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null

        };
        container = this;

        store.dispatch(serviceActionListFilter([]))
        this.props.callserviceActionRefresh();
        this.getData(1)
        this.props.navigation.addListener('focus', () => {
                /*   store.dispatch(serviceActionListFilter([]))
                   props.callserviceActionRefresh();
                   this.getData(1)*/

            }
        )
        this.props.navigation.addListener('blur', () => {}
        )

    }

    state = {
        show: false
    };

    componentWillReceiveProps(props) {


        if (props.allResult && props.allResult.status && this.state.OneDo) {
            let ticketUnit = props.allResult.ticketUnit;
            let ticketService = props.allResult.ticketService;
            let ticketPriority = props.allResult.ticketPriority;

            let valueService = ticketService && ticketService.length > 0 ? ticketService.find(obj => (obj.label.search(this.props.DataSplashSatiaScreen.Account ? this.props.DataSplashSatiaScreen.Account.Type : "") > -1)) : null
            this.setState({
                    OneDo: false,
                    indexSelectCheckBoxUnit: ticketUnit && ticketUnit.length > 0 ? ticketUnit[0].value : null,
                    // indexSelectCheckBoxService: valueService ? valueService.value : null,

                    indexSelectCheckBoxService: valueService ? valueService.value : (ticketService && ticketService.length > 0 ? ticketService[0].value : null),
                    indexSelectCheckBoxPriority: ticketPriority && ticketPriority.length > 1 ? ticketPriority[1].value : null,
                },
                () => {

                }
            )
        }

    }

    async componentDidMount() {

    }

    componentWillUnmount() {

    }

    async getData(page) {


        container.setState({
            OneDo: true,
            visibleModal: ""
        })
        page = page ? page : 1
        //  let {item, data} = this.props.route.params

        let after = "0000-00-00";
        //   this.props.callService(urlListMessageOperatorSatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListMessageOperatorSatiaScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListMessageOperatorSatiaScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListMessageOperatorSatiaScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListMessageOperatorSatiaScreen, _GET, page, 10)
  */

        let paramss = {
            "_operation": typeExport._Fire,

            "mode": typeExport._GetDashboard,
            "lang": i18n.locale,
            "_session": store.getState().reducerSplashSatiaScreen.token,
            "page": page,

        };
        if (store.getState().reducerSplashSatiaScreen.Connection) {

            container.props.callService(typeExport._baseUrlSatia + "support/tickets", paramss, typeExport.TypeGetListMessageOperatorSatiaScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatia + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatiaFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    async setData(page) {

        if (Tools.CheckValue(this.state.title)) {
            if (Tools.CheckValue(this.state.Description)) {
                this.setServer(page)
            }
            else {
                HMAlert(
                    i18n.t('constant.message'),
                    "توضیحات را وارد نمایید",
                    [
                        // {text: 'Ask me later', onPress: () => {}},
                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                        {
                            text: i18n.t('constant.ok'), onPress: () => {
                                // NavigationService.navigateParams("WebServiceScreen", {noRefresh: true})

                            }
                        },
                    ],
                    {cancelable: false}
                )

            }
        }
        else {
            HMAlert(
                i18n.t('constant.message'),
                "عنوان را وارد نمایید",
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                            // NavigationService.navigateParams("WebServiceScreen", {noRefresh: true})

                        }
                    },
                ],
                {cancelable: false}
            )

        }
    }

    setServer(page) {
        //  let {item, data} = this.props.route.params

        let after = "0000-00-00";
        //   this.props.callService(urlListMessageOperatorSatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListMessageOperatorSatiaScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListMessageOperatorSatiaScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListMessageOperatorSatiaScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListMessageOperatorSatiaScreen, _GET, page, 10)
  */

        let paramss = {
            "_operation": typeExport._Fire,

            "mode": typeExport._GetDashboard,
            "lang": i18n.locale,
            "_session": store.getState().reducerSplashSatiaScreen.token,

            // "unitTicket": this.state.typeTicketUnit,
            // "serviceTicket": this.state.typeTicketService,
            // "priorityTicket": this.state.typeTicketPriority,
            "unitTicket": this.state.indexSelectCheckBoxUnit,
            "serviceTicket": this.state.indexSelectCheckBoxService,
            "priorityTicket": this.state.indexSelectCheckBoxPriority,
            "titleTicket": this.state.title,
            "messageTicket": this.state.Description,
        };
        if (store.getState().reducerSplashSatiaScreen.Connection) {

            this.props.callService(typeExport._baseUrlSatia + "support/newTicket", paramss, typeExport.TypeSetListMessageOperatorSatiaScreen, typeExport._POST, page, typeExport._Count, null, this.getData)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatia + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatiaFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }
    }


    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    _onMapReady = () => this.setState({marginBottom: 0})

    render() {
        let {item} = this.props.route.params
        let myLocation = store.getState().reducerSplashSatiaScreen.Location;

        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        //let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        return (
            <View style={{position: 'relative', flex: 1,}}>


              {/*  <HMImageBackground

                />*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBarSatia
                            menu
                            back

                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListServiceHistorySatia.title')}
                            text={(item.name ? item.name : (item.title ? item.title : ''))}
                            //text={(data.name ? data.name : (data.title ? data.title : ''))}
                            //  text={this.state.arraySelected.length}


                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />

                        <View style={{flex: 1}}>
                            {/*<View*/}
                            {/*style={{*/}
                            {/*height: moderateScale(42),*/}
                            {/*backgroundColor: Colors.colorPrimary,*/}
                            {/*flexDirection: 'row',*/}
                            {/*marginHorizontal: moderateScale(10),*/}
                            {/*marginTop: moderateScale(6),*/}
                            {/*borderRadius: moderateScale(14),*/}
                            {/*borderColor: Colors.colorDark,*/}
                            {/*borderWidth: moderateScale(1),*/}
                            {/*//  marginBottom: moderateScale(10)*/}
                            {/*// width:'100%'*/}
                            {/*}}>*/}

                            {/*<View*/}
                            {/*style={{*/}
                            {/*flex: .8,*/}
                            {/*height: moderateScale(40),*/}
                            {/*backgroundColor: Colors.white,*/}
                            {/*borderRadius: moderateScale(14),*/}
                            {/*flexDirection: 'row',*/}
                            {/*paddingHorizontal: moderateScale(4),*/}
                            {/*alignItems: 'center',*/}

                            {/*}}>*/}

                            {/*<View style={{width: moderateScale(5)}}/>*/}

                            {/*<View style={{flex: 1, marginHorizontal: moderateScale(8)}}>*/}
                            {/*<HMTextInputEfects value={this.state.trackingCode}*/}
                            {/*onChangeText={(text) => this.setState({trackingCode: text}, () => {*/}
                            {/*//  this.getJsonMap()*/}

                            {/*})}*/}
                            {/*_height={40}*/}
                            {/*//  autoFocus*/}
                            {/*//  placeholder={i18n.t('constant.filter')}*/}
                            {/*placeholder={i18n.t('constant.TrackingCode')}*/}
                            {/*NoShowPlaceholder*/}
                            {/*//باتد_width={'80%'}*/}
                            {/*// icon={"md-person"}*/}
                            {/*style={{*/}
                            {/*fontSize: moderateScale(11),*/}

                            {/*// marginTop: moderateScale(6)*/}
                            {/*}} underlineColorAndroid="transparent"/>*/}
                            {/*</View>*/}


                            {/*</View>*/}
                            {/*<TouchableOpacity*/}
                            {/*onPress={() => {*/}
                            {/*this.getData(1)*/}
                            {/*//  this.nextScreen(item, type)*/}
                            {/*}}*/}
                            {/*style={{*/}
                            {/*flex: .2,*/}
                            {/*height: moderateScale(32),*/}
                            {/*backgroundColor: Colors.colorPrimary,*/}
                            {/*borderTopEndRadius: moderateScale(14),*/}
                            {/*borderBottomEndRadius: moderateScale(14),*/}
                            {/*alignItems: 'center',*/}
                            {/*justifyContent: 'center'*/}
                            {/*}}>*/}

                            {/*<HMTextView*/}
                            {/*//text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}*/}
                            {/*text={i18n.t('constant.Search')}*/}
                            {/*type={"bold"}*/}
                            {/*style={{*/}
                            {/*textAlign: "center",*/}
                            {/*color: Colors.white,*/}
                            {/*fontSize: moderateScale(11)*/}

                            {/*}}/>*/}
                            {/*</TouchableOpacity>*/}

                            {/*</View>*/}

                            <EmptyView empty={this.props.empty}/>
                            <FlatList
                                data={this.props.results}
                                // data={[
                                //     {
                                //         id: 1,
                                //         date: "1399/03/12",
                                //         title: "اینترنت قطع شده",
                                //         part: "پشتيباني فني",
                                //         priority: "كم",
                                //         status: "باز است",
                                //     },
                                //     {
                                //         id: 1,
                                //         date: "1399/03/11",
                                //         title: "سرعت اینترنت کم است",
                                //         part: "پشتيباني فني",
                                //         priority: "زیاد",
                                //         status: "باز است",
                                //     },
                                //     {
                                //         id: 1,
                                //         date: "1399/03/10",
                                //         title: "اینترنت قطع شده",
                                //         part: "پشتيباني فني",
                                //         priority: "بسیار بالا",
                                //         status: "بسته است",
                                //     },
                                // ]}
                                renderItem={({item, index}) => {
                                    return <TouchableOpacity
                                        onPress={() => {
                                            NavigationService.navigateParams("ListQuestionAndAnswerSatiaScreen", {item});

                                        }}

                                        style={{
                                            flex: 1,
                                            overflow: 'hidden',
                                            //height:  moderateScale(100),
                                            // padding: moderateScale(4),
                                            margin: moderateScale(5),
                                            borderWidth: moderateScale(1),
                                            borderRadius: moderateScale(2),
                                            borderColor: '#ddd',
                                            borderBottomWidth: 0,
                                            shadowColor: '#000',
                                            shadowOffset: {width: 0, height: moderateScale(.7)},
                                            shadowOpacity: 0.6,
                                            shadowRadius: moderateScale(2),
                                            elevation: moderateScale(1),
                                            // marginLeft: moderateScale(1),
                                            // marginRight: moderateScale(1),
                                            // marginTop: moderateScale(1),
                                            // marginBottom: moderateScale(1),
                                            backgroundColor: item.background_color ? item.background_color : Colors.white,
                                        }}>
                                        <View style={{
                                            width: '100%',
                                            backgroundColor: item.Closer ? Colors.blackLight : Colors.yellow,
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            padding: moderateScale(6)
                                        }}>

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={item.Priority}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.white,
                                                    fontSize: moderateScale(14),


                                                }}/>

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={item.Date}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.white,
                                                    fontSize: moderateScale(14),


                                                }}/>

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={item.Status}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.white,
                                                    fontSize: moderateScale(14),


                                                }}/>
                                        </View>
                                        <View style={{padding: moderateScale(6)}}>
                                            <View style={{flexDirection: 'row',}}>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={"عنوان" + " : "}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14),


                                                    }}/>

                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={item.Subject}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(14),


                                                    }}/>


                                            </View>
                                            {/*   <View style={{flexDirection: 'row'}}>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={"بخش" + " : "}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14),


                                                    }}/>

                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={item.Staff}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(14),


                                                    }}/>
                                            </View>
                                            <View style={{flexDirection: 'row'}}>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={"اولویت" + " : "}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14),


                                                    }}/>

                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={item.Priority}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(14),


                                                    }}/>
                                            </View>*/}
                                            <View style={{flexDirection: 'row'}}>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={"بخش" + " : "}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14),


                                                    }}/>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={item.Staff}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(14),


                                                    }}/>

                                            </View>
                                            <View style={{flexDirection: 'row'}}>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={"توضیحات" + " : "}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14),


                                                    }}/>

                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={item.responses && item.responses.length > 0 && item.responses[0].Response ? item.responses[0].Response : ''}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(14),


                                                    }}/>
                                            </View>

                                        </View>
                                    </TouchableOpacity>
                                }}
                                //renderItem={this.renderItem}
                                keyExtractor={(item, index) => index.toString()}
                                ListEmptyComponent={() =>
                                    null}
                                //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={typeExport._Count-1}   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                            />
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }

                            {/*     <HMModal
                                visibleModal={this.state.visibleModal === 'Modal'}
                                hiddenModal={() => this.hiddenModal()}
                                textInput={this.state["text" + this.state.indexFilter]}
                                SearchFilterFunction={text => this.SearchFilterFunction("array", "text", text, childFilter)}
                                //textInput={this.state.mobile}
                                dataSource={this.state["dataSource" + this.state.indexFilter]}
                                // onChange={() => this.onChangeCondition(index, item)}
                                onChangeItem={this.onChange}
                            />*/}

                            <TouchableOpacity
                                onPress={() => {

                                    if (this.props.allResult) {
                                        container.setState({
                                            visibleModal: true
                                        })
                                    }
                                    // else
                                    //     ParentScreen.ShowMessageBack("لطفا صبر نمایید"),
                                    //         setTimeout(function () {
                                    //
                                    //             // alert("df")
                                    //         }, 1000)

                                }}
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    overflow: 'hidden',
                                    width: moderateScale(48),
                                    height: moderateScale(48),
                                    borderRadius: moderateScale(24),
                                    // padding: moderateScale(4),
                                    margin: moderateScale(5),
                                    borderWidth: moderateScale(1),
                                    borderColor: '#ddd',
                                    borderBottomWidth: 0,
                                    shadowColor: '#000',
                                    shadowOffset: {width: 0, height: moderateScale(.7)},
                                    shadowOpacity: 0.6,
                                    shadowRadius: moderateScale(2),
                                    elevation: moderateScale(1),
                                    // marginLeft: moderateScale(1),
                                    // marginRight: moderateScale(1),
                                    // marginTop: moderateScale(1),
                                    // marginBottom: moderateScale(1),
                                    backgroundColor: Colors.colorSecondPrimary,
                                    alignItems: 'center',
                                    justifyContent: "center"
                                }}>
                                <HMIcon name="md-add" style={{
                                    color: Colors.white,
                                    fontSize: moderateScale(28),
                                    //  padding: moderateScale(4),
                                    alignSelf: "center",
                                }}/>
                            </TouchableOpacity>

                            {this.renderModal()}
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderItem = ({item, index}) => {
        return <View/>
    }

    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            <View style={[{
                //marginVertical: moderateScale(15),
                height: moderateScale(30),
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row'
            }]}>
                {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                {
                    checkIndex ?

                        <View style={{flexDirection: 'row'}}>


                            <TouchableOpacity
                                onPress={() => {
                                    //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                    let arr = container.state.arraySelected;

                                    if (idx !== -1) {
                                        arr.splice(idx, 1)

                                        container.setState({
                                                arraySelected: arr,
                                                [`selectFilter${index}`]: {
                                                    value: item.name,
                                                    id: item.id,
                                                    type: item.type
                                                },
                                                visibleModal: false,
                                            },

                                            () => {
                                                container.getData(1)
                                            }
                                        )
                                    }
                                    // container.setState({
                                    //         [`selectFilter${index}`]: {
                                    //             value: item.name,
                                    //             id: item.id,
                                    //             type:item.type
                                    //         },
                                    //         visibleModal: false,
                                    //     },
                                    //     () => {
                                    //         let arr = this.state.arraySelected;
                                    //         this.setState({
                                    //                 arraySelected: arr
                                    //             },
                                    //             () => {
                                    //                 container.getData(1)
                                    //             }
                                    //         )
                                    //
                                    //     }
                                    // )

                                }}
                                style={{
                                    alignSelf: 'center',
                                    //  marginHorizontal:moderateScale(6)
                                }}>
                                <HMIcon name={"md-close"} style={{
                                    fontSize: moderateScale(20),
                                    color: '#f2f2f2'
                                }}/>

                            </TouchableOpacity>
                        </View>
                        :
                        null


                }
                {
                    checkIndex ?
                        <View style={{width: moderateScale(6),}}/>

                        :
                        null
                }
                <TouchableOpacity
                    onPress={() => {

                        this.setState({
                                indexFilter: index,
                                typeFilter: item.type,
                                ["dataSource" + index]: item.list
                            },
                            () => {
                                //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                this.onShow('Modal')

                            })
                    }
                    }

                    style={{alignItems: 'center', flexDirection: 'row'}}
                >

                    <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                style={{
                                    color: checkIndex ? Colors.white : Colors.gray,
                                    //marginHorizontal: moderateScale(6),
                                    fontSize: moderateScale(14),
                                    textAlign: 'center',

                                }}/>
                    <HMIcon name={"ios-arrow-down"} style={{
                        fontSize: moderateScale(11),
                        color: checkIndex ? '#f2f2f2' : Colors.gray,
                        marginHorizontal: moderateScale(2),
                        marginTop: moderateScale(3)
                    }}/>
                </TouchableOpacity>


            </View>
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashSatiaScreen.Connection) {
            this.getData(1)
        } else {
           // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListMessageOperatorSatiaScreen, `?type=${this.props.typee}&city=`, TypeGetListMessageOperatorSatiaScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {
        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashSatiaScreen.Connection) {
            // this.props.callService(urlListMessageOperatorSatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListMessageOperatorSatiaScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id,
                        value: data.name,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                //indexFilterCondition: index,
                visibleModal: false,
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {
        container.setState({
                visibleModal: false
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }

    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;
        const newData = childFilter.list.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }


    renderModal(data) {

        return (
            <HMModal
                isVisible={this.state.visibleModal}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={() => this.hiddenModal()}
                onBackButtonPress={() => this.hiddenModal()}
            >
                <KeyboardAvoidingView style={{
                    width: "100%",  padding: moderateScale(16),
                    backgroundColor: Colors.white,
                    border: moderateScale(4)
                }} behavior={"padding"}
                                      enabled={Platform.OS === "ios"}>


                    <ScrollView
                        style={{
                            width: '100%'

                        }}
                        ref={scroll => this._scroll = scroll}
                        keyboardShouldPersistTaps="handled"
                    >
                        {
                            this.props.allResult ?
                                <View style={{width: '100%'}}>

                                    <View
                                        style={{
                                            //  flexDirection: 'row',
                                            // backgroundColor: "#ee005c",

                                            flex: 1,
                                            // backgroundColor: "#8feeeb",

                                            //width: "96%",
                                            //alignSelf: 'center',
                                            //  alignItems: 'center',
                                            marginVertical: moderateScale(3)
                                        }}>
                                        <HMTextView
                                            //  numberOfLines={1}
                                            type={'bold'}
                                            //  text={i18n.t('constant.Gender') + " : "}
                                            text={"واحد"}
                                            style={{
                                                //marginTop: moderateScale(18),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.blackLight,
                                                // marginEnd: moderateScale(10),
                                                fontSize: moderateScale(14),
                                                //  textAlign: 'center',
                                                //  marginHorizontal: moderateScale(8)

                                            }}/>


                                        <HMListCheckBox
                                            data={{
                                                list: this.props.allResult.ticketUnit,
                                                indexSelect: this.state['indexSelectCheckBoxUnit'],
                                                name: 'Unit',

                                            }}
                                            onPress={this.onPressSelectCheckBox
                                            }

                                        />
                                    </View>
                                    <View
                                        style={{
                                            //  flexDirection: 'row',
                                            // backgroundColor: "#ee005c",

                                            flex: 1,
                                            // backgroundColor: "#8feeeb",

                                            //width: "96%",
                                            //alignSelf: 'center',
                                            //  alignItems: 'center',
                                            marginVertical: moderateScale(3)
                                        }}>
                                        <HMTextView
                                            //  numberOfLines={1}
                                            type={'bold'}
                                            //  text={i18n.t('constant.Gender') + " : "}
                                            text={"سرویس"}
                                            style={{
                                                //marginTop: moderateScale(18),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.blackLight,
                                                // marginEnd: moderateScale(10),
                                                fontSize: moderateScale(14),
                                                // textAlign: 'center',
                                                //  marginHorizontal: moderateScale(8)

                                            }}/>


                                        <HMListCheckBox
                                            data={{
                                                list: this.props.allResult.ticketService,
                                                indexSelect: this.state['indexSelectCheckBoxService'],
                                                name: 'Service',

                                            }}
                                            onPress={this.onPressSelectCheckBox
                                            }

                                        />
                                    </View>
                                    <View
                                        style={{
                                            //  flexDirection: 'row',
                                            // backgroundColor: "#ee005c",

                                            flex: 1,
                                            // backgroundColor: "#8feeeb",

                                            //width: "96%",
                                            //alignSelf: 'center',
                                            //  alignItems: 'center',
                                            marginTop: moderateScale(3)
                                        }}>
                                        <HMTextView
                                            //  numberOfLines={1}
                                            type={'bold'}
                                            //  text={i18n.t('constant.Gender') + " : "}
                                            text={"اولویت"}
                                            style={{
                                                //marginTop: moderateScale(18),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.blackLight,
                                                // marginEnd: moderateScale(10),
                                                fontSize: moderateScale(14),
                                                // textAlign: 'center',
                                                //  marginHorizontal: moderateScale(8)

                                            }}/>


                                        <HMListCheckBox
                                            data={{
                                                list: this.props.allResult.ticketPriority,
                                                indexSelect: this.state['indexSelectCheckBoxPriority'],
                                                name: 'Priority',

                                            }}
                                            onPress={this.onPressSelectCheckBox
                                            }

                                        />
                                    </View>

                                    {/*          <HMSelectInput
                                        onValueChange={(value, index, indexParent, itemParent) => {
                                            this.setState({
                                                    typeTicketUnit: value
                                                },
                                                () => {

                                                })
                                        }}
                                        loading={false} value={i18n.t('constant.SelectItem')}
                                        //text={i18n.t('constant.DeviceType')}
                                        text={"واحد"}
                                        options={this.props.allResult.ticketUnit}
                                        //     options={[{
                                        //     value: 'پشتیبانی فنی', label: 'پشتیبانی فنی',
                                        // }]}
                                        //
                                    />
                                    <HMSelectInput
                                        onValueChange={(value, index, indexParent, itemParent) => {
                                            this.setState({
                                                    typeTicketService: value
                                                },
                                                () => {

                                                })
                                        }}
                                        loading={false} value={i18n.t('constant.SelectItem')}
                                        //text={i18n.t('constant.DeviceType')}
                                        text={"سرویس"}
                                        options={this.props.allResult.ticketService}

                                        // options={[
                                        //     {
                                        //         value: 'اینترنت ADSL', label: 'اینترنت ADSL',
                                        //     }, {
                                        //         value: 'اینترنت WIRELESS', label: 'اینترنت WIRELESS',
                                        //     },
                                        // ]}

                                    />
                                    <HMSelectInput
                                        onValueChange={(value, index, indexParent, itemParent) => {
                                            this.setState({
                                                    typeTicketPriority: value
                                                },
                                                () => {

                                                })
                                        }}
                                        loading={false} value={i18n.t('constant.SelectItem')}
                                        //text={i18n.t('constant.DeviceType')}
                                        text={"اولویت"}
                                        options={this.props.allResult.ticketPriority}

                                        // options={[
                                        //     {
                                        //         value: 'کم', label: 'کم',
                                        //     }, {
                                        //         value: 'عادی', label: 'عادی',
                                        //     }, {
                                        //         value: 'بالا', label: 'بالا',
                                        //     }, {
                                        //         value: 'بسیار بالا', label: 'بسیار بالا',
                                        //     },
                                        // ]}
                                    />*/}
                                </View>
                                :
                                null
                        }

                        <HMTextInputEfects
                            //_ref={scroll => this["inputtitle"] = scroll}
                            onRef={scroll => container["inputtitle"] = scroll}

                            refName={"title"}

                            type={"CostumeFumi"}
                            value={this.state.title}

                            label={i18n.t('constant.title')}
                            onChangeText={text => this.setState({
                                title: text
                            })}
                            iconClass={FontAwesomeIcon}
                            iconName={'phone'}
                            //keyboardType={'number-pad'}
                            // _scroll={this._scroll}

                            // secureTextEntry={true}
                            onSubmitEditing={() => this._focusNextField("inputDescription")}
                            containerStyle={{}}
                            containerInputStyle={{
                                borderWidth: moderateScale(1),

                                borderRadius: moderateScale(10),
                                // overflow: 'hidden',
                                marginBottom: moderateScale(4)
                            }}
                            border={true}

                        />
                        <HMTextInputEfects
                            // _ref={scroll => this["inputDescription"] = scroll}
                            onRef={scroll => container["inputDescription"] = scroll}

                            refName={"Description"}

                            type={"CostumeFumi"}
                            value={this.state.Description}

                            label={i18n.t('constant.Description')}
                            onChangeText={text => this.setState({
                                Description: text
                            })}
                            iconClass={FontAwesomeIcon}
                            iconName={'phone'}
                            //keyboardType={'number-pad'}
                            // _scroll={this._scroll}

                            // secureTextEntry={true}
                            // onSubmitEditing={() => {}}
                            //  containerStyle={{}}
                            containerInputStyle={{
                                borderWidth: moderateScale(1),

                                borderRadius: moderateScale(10),
                                // overflow: 'hidden',
                                marginVertical: moderateScale(4)
                            }}
                            border={true}
                            multiline={true}

                            height={moderateScale(80)}
                            onSubmitEditing={() => {

                            }}


                        />
                        <TouchableOpacity
                            onPress={() => {
                                this.setData()
                                // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                //this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                //    this.setState({selectedService: "44"})
                                //  this.goBack();
                            }}
                            style={{
                                width: '92%',
                                height: moderateScale(42),
                                alignSelf: 'center',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: Colors.colorPrimary,
                                borderRadius: moderateScale(6),
                                marginTop: moderateScale(10),
                                marginBottom: moderateScale(4),

                            }}>

                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={i18n.t('constant.Registration')} type={"bold"}
                                style={{
                                    fontSize: moderateScale(13),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.white
                                }}/>
                        </TouchableOpacity>


                    </ScrollView>

                    {
                        this.props.isLoadingSet ?
                            <DialogLoadingCustomize/>
                            : null
                    }
                </KeyboardAvoidingView>
            </HMModal>
        );
    }

    _onRef = (property, view) => {
        this[property] = view
    }

    _focusNextField(nextField) {


        container[nextField].focus()
        // container[nextField].input.current.measureLayout(
        //     ReactNative.findNodeHandle(container._scroll),
        //     (x, y) => {
        //         container._scroll.scrollTo({x: 0, y: y - moderateScale(40), animated: true});
        //     }
        // );



    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                //   ['indexSelectCheckBox' + name]: check ? null : (item.id ? item.id : item.value)
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value)
            },
            () => {
            })
    }
}
